export type AccessPermission =
  | 'dashboard'
  | 'users'
  | 'emails'
  | 'attendance'
  | 'events'
  | 'videos'
  | 'connections'
  | 'announcements'
  | 'news'
  | 'sponsor_stories'
  | 'reports'
  | 'whatsapp'
  | 'organization_management';

export interface AccessControlledAdminProfile {
  role: 'superAdmin' | 'admin' | 'employee';
  access: string[];
}

export const ALL_ACCESS_PERMISSIONS: AccessPermission[] = [
  'dashboard',
  'users',
  'emails',
  'attendance',
  'events',
  'videos',
  'connections',
  'announcements',
  'news',
  'sponsor_stories',
  'reports',
  'whatsapp',
  'organization_management'
];

export const hasAccessPermission = (
  profile: AccessControlledAdminProfile | null | undefined,
  permission?: AccessPermission
): boolean => {
  if (!profile) {
    return false;
  }

  if (profile.role === 'superAdmin') {
    return true;
  }

  if (!permission) {
    return true;
  }

  return Array.isArray(profile.access) && profile.access.includes(permission);
};

export const permissionToRoute = (permission: AccessPermission): string => {
  switch (permission) {
    case 'dashboard':
      return '/home';
    case 'users':
      return '/users';
    case 'emails':
      return '/emails';
    case 'attendance':
      return '/attendance';
    case 'events':
      return '/events';
    case 'videos':
      return '/videos';
    case 'connections':
      return '/connections';
    case 'announcements':
      return '/announcements';
    case 'news':
      return '/news';
    case 'sponsor_stories':
      return '/sponsor-stories';
    case 'reports':
      return '/reports';
    case 'whatsapp':
      return '/whatsapp';
    case 'organization_management':
      return '/organization';
  }
};

export const getDefaultAdminRoute = (
  profile: AccessControlledAdminProfile | null | undefined
): string => {
  if (!profile) {
    return '/login';
  }

  for (const permission of ALL_ACCESS_PERMISSIONS) {
    if (hasAccessPermission(profile, permission)) {
      return permissionToRoute(permission);
    }
  }

  return '/login';
};
